import { Stack } from "@mui/material";
import { ASSETS_COLORS } from "src/theme/palette";

// ----------------------------------------------------------------------

type Props = {
	color: string;
};

export default function SquareColor({ color }: Props) {
	return (
		<Stack
			sx={{
				top: 0,
				width: 160,
				height: 160,
				right: -65,
				opacity: 0.12,
				zIndex: -1,
				borderRadius: 4,
				position: "absolute",
				transform: "rotate(40deg)",
				background: `linear-gradient(to right, ${ASSETS_COLORS[color].main} 0%, ${ASSETS_COLORS[color].darker} 100%)`
			}}
		/>
	);
}
